@use '@hevoio/hevo-ui-toolkit/styles/mixins' as hevo-toolkit-mixins;
@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.treeView {
  padding: 0;
  .treeContent {
    display: none;
  }

  .treeItem {
    list-style-type: none;
    &.expanded .treeContent {
      display: flex;
    }
  }
}

.folderContent {
  padding-left:  hevo-toolkit-variables.$spacer;
  display: flex;
  flex-direction: column;
  position: relative;
}

.folderInfoContainer {
  @include  hevo-toolkit-mixins.clear-btn-style();
  width: 100%;
  display: flex;
  align-items: center;
  padding:  hevo-toolkit-variables.$spacer * 0.75  hevo-toolkit-variables.$spacer;
  cursor: pointer;
  justify-content: space-between;
  position: relative;
  height: 40px;
  &:focus {
    background-color:  hevo-toolkit-variables.$menu-active-bg;
  }
}

.folderInfoContainer:hover {
  .copySm {
    display: flex;
  }
}

.folderNameContainer {
  flex: 1;
  flex-basis: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.folderName {
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight:  hevo-toolkit-variables.$font-weight-medium;
  white-space: nowrap;
}

.folderToggleArrow {
  margin-right:  hevo-toolkit-variables.$spacer * 0.5;
  transform: rotate(-90deg);
  flex-shrink: 0;
}

.folderToggleArrowToggled {
  transform: rotate(0deg);
}

.folderIcon {
  font-size:  hevo-toolkit-variables.$spacer * 0.75;
  margin-right:  hevo-toolkit-variables.$spacer * 0.25;
  flex-shrink: 0;
}

.relations {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.relationGroupTrigger {
  margin-left:  hevo-toolkit-variables.$spacer * 0.25;
}

.collapsedRelationsTrigger {
  @include  hevo-toolkit-mixins.thumbnail-container(16px, 3px, false, true);
  border: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
}

hr {
  border: solid  hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
}

.copySm {
  margin-left:  hevo-toolkit-variables.$spacer * 0.5;
  display: none;
  flex-shrink: 0;
}

.moreIcon {
  margin-right: -( hevo-toolkit-variables.$spacer) * 0.25 !important;
  margin-left:  hevo-toolkit-variables.$spacer * 0.25 !important;
  right: 0;
}
